import {
  PrimaryButton,
  PrimaryButtonProps,
  SpinnerIcon,
} from '@grays-npm/component-library';
import React from 'react';
import styled from 'styled-components';

const Button = styled(PrimaryButton)`
  min-width: 184px;
`;

const Spinner = styled(SpinnerIcon)`
  fill: ${({ theme }) => theme.colors.primary.white};
`;

type LoadingButtonProps = PrimaryButtonProps & {
  isLoading?: boolean;
  isSuccess?: boolean;
  successText?: string;
  onClose: () => void;
};

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading = false,
  isSuccess = false,
  successText = 'Continue',
  onClick,
  onClose,
  children,
  ...props
}) => {
  return (
    <Button
      onClick={isSuccess ? onClose : onClick}
      {...(isSuccess && { contextColor: 'success' })}
      {...props}
    >
      {isLoading ? <Spinner width={32} /> : isSuccess ? successText : children}
    </Button>
  );
};
